<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Forms from "../../../../mixins/Forms";

import axios from 'axios';

/**
 * User edit component
 */
export default {
  page: {
    title: "Edit User",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  mixins: [Forms],
  created() {
    this.loadUser(this.$route.params.id);
    this.loadAllRoles();
    this.loadAllOffices();
  },
  data() {
    return {
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "Edit User",
          active: true
        }
      ],

      user: null,
      name: '',
      roles: [],
      officeId: null,

      isCx: null,

      isTravelConsultant: null,
      travelConsultantName: null,

      notifyOfIncidentReports: null,
      notifyOfIatGroupIncidentReports: null,
      notifyOfIatFitIncidentReports: null,
      notifyOfIjtGroupIncidentReports: null,
      notifyOfIjtFitIncidentReports: null,
      escalateWhatsApp: null,

      serverErrors: [],
      isLoading: false,
      isSaving: false,

      allRoles: [],
      isLoadingAllRoles: false,

      allOffices: [],
      isLoadingAllOffices: false
    };
  },
  methods: {
    loadUser(id) {
      let vm = this;
      vm.roles = [];
      vm.user = null;
      vm.isLoading = true;
      axios.get(API_BASE + '/users/' + id).then(r => {
        vm.isLoading = false;
        vm.user = r.data;
        vm.name = vm.user.name;
        vm.roles = _.map(vm.user.roles, 'name');
        vm.officeId = vm.user.office_id;
        vm.isCx = vm.user.is_cx;
        vm.isTravelConsultant = vm.user.is_travel_consultant;
        vm.travelConsultantName = vm.user.travel_consultant_name;
        vm.notifyOfIncidentReports = vm.user.notify_of_incident_reports;
        vm.notifyOfIatGroupIncidentReports = vm.user.notify_of_iat_group_incident_reports;
        vm.notifyOfIatFitIncidentReports = vm.user.notify_of_iat_fit_incident_reports;
        vm.notifyOfIjtGroupIncidentReports = vm.user.notify_of_ijt_group_incident_reports;
        vm.notifyOfIjtFitIncidentReports = vm.user.notify_of_ijt_fit_incident_reports;
        vm.escalateWhatsApp = vm.user.escalate_whatsapp;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },

    loadAllRoles() {
      let vm = this;
      vm.allRoles = null;
      vm.isLoadingAllRoles = true;
      axios.get(API_BASE + '/roles').then(r => {
        vm.isLoadingAllRoles = false;
        vm.allRoles = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoadingAllRoles = false;
        vm.allRoles = [];
        vm.setErrors(e);
      });
    },

    loadAllOffices() {
      let vm = this;
      vm.allOffices = null;
      vm.isLoadingAllOffices = true;
      axios.get(API_BASE + '/offices').then(r => {
        vm.isLoadingAllOffices = false;
        vm.allOffices = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoadingAllOffices = false;
        vm.allOffices = [];
        vm.setErrors(e);
      });
    },

    attemptSave() {
      this.save();
    },

    save() {
      let vm = this;
      vm.isSaving = true;
      axios.put(API_BASE + '/users/' + this.user.id, {
        name: vm.name,
        roles: vm.roles,
        office_id: vm.officeId,
        is_cx: vm.isCx,
        is_travel_consultant: vm.isTravelConsultant,
        travel_consultant_name: vm.travelConsultantName,
        notify_of_incident_reports: vm.notifyOfIncidentReports,
        notify_of_iat_group_incident_reports: vm.notifyOfIatGroupIncidentReports,
        notify_of_iat_fit_incident_reports: vm.notifyOfIatFitIncidentReports,
        notify_of_ijt_group_incident_reports: vm.notifyOfIjtGroupIncidentReports,
        notify_of_ijt_fit_incident_reports: vm.notifyOfIjtFitIncidentReports,
        escalate_whatsapp: vm.escalateWhatsApp
      }).then(r => {
        vm.isSaving = false;
        vm.$router.push('/settings/users/');
        this.$notify.success({
          title: 'Success!',
          message: 'User updated successfully'
        });
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  },
  computed: {
    title() {
      return this.user ? `Edit User - ${this.user.name}` : "Edit User";
    }
  },
  watch: {
    $route() {
      this.loadUser(this.$route.params.id);
      this.loadAllRoles();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <errors :error-list="serverErrors"></errors>
    <loading-screen :is-loading="isLoading || isSaving || isLoadingAllRoles || isLoadingAllOffices"></loading-screen>
    <div class="row" v-if="user && (!isLoadingAllRoles) && (!isLoadingAllOffices)">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
            <form @submit.prevent="attemptSave">

              <!-- Name -->
              <div class="form-group row mb-4">
                <label for="name" class="col-form-label col-lg-2">Name</label>
                <div class="col-lg-10">
                  <div class="mb-3 mt-2">
                    <input type="text" class="form-control" style="max-width: 500px;" id="name" name="name"
                      v-model="name" />

                    <!-- <small class="form-text text-muted"> -->
                      <!-- To match against multiple names, separate using commas. Such as "John Doe, Jane Smith, etc." -->
                    <!-- </small> -->
                  </div>
                </div>
              </div>
              <!-- / Name --> 

              <!-- Roles -->
              <div class="form-group row mb-4">
                <label for="name" class="col-form-label col-lg-2">Roles</label>
                <div class="col-lg-10">
                  <div class="mb-3 form-check" v-for="(role, i) in allRoles" :key="i">
                    <label class="form-check-label">
                      <input id="checkbox" class="form-check-input" name="name" type="checkbox" :value="role.name"
                        v-model="roles" />
                      <div style="padding-top: 2px;">{{ role.name }}</div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- / Roles -->

              <!-- Offices -->
              <div class="form-group row mb-4">
                <label for="name" class="col-form-label col-lg-2">Offices</label>
                <div class="col-lg-10">
                  <div class="mb-3 form-check" v-for="(office, i) in allOffices" :key="`office-${i}`">
                    <label class="form-check-label">
                      <input id="checkbox" class="form-check-input" name="name" type="radio" :value="office.id"
                        v-model="officeId" />
                      <div style="padding-top: 2px;">{{ office.name }}</div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- / Offices -->

              <!-- Is CX -->
              <div class="form-group row mb-4">
                <label for="isCx" class="col-form-label col-lg-2">Is CX?</label>
                <div class="col-lg-10">
                  <div class="mb-3 form-check">
                    <label class="form-check-label mt-1">
                      <input id="checkbox" class="form-check-input" name="isCx" type="checkbox"
                        :value="isCx" v-model="isCx" />
                      <div style="padding-top: 2px;">Yes, this user works in CX</div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- / Is CX -->

              <!-- Is Travel Consultant -->
              <div class="form-group row mb-4">
                <label for="isTravelConsultant" class="col-form-label col-lg-2">Is Travel Consultant?</label>
                <div class="col-lg-10">
                  <div class="mb-3 form-check">
                    <label class="form-check-label mt-1">
                      <input id="checkbox" class="form-check-input" name="isTravelConsultant" type="checkbox"
                        :value="isTravelConsultant" v-model="isTravelConsultant" />
                      <div style="padding-top: 2px;">Yes, this user is a travel consultant</div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- / Is Travel Consultant -->

              <!-- Travel Consultant Name -->
              <div class="form-group row mb-4">
                <label for="travelConsultantName" class="col-form-label col-lg-2">Travel Consultant Name <br />(For Matching To Axum)</label>
                <div class="col-lg-10">
                  <div class="mb-3 mt-2">
                    <input type="text" class="form-control" style="max-width: 500px;" id="travelConsultantName" name="travelConsultantName"
                      v-model="travelConsultantName" />

                    <small class="form-text text-muted">
                      To match against multiple names, separate using commas. Such as "John Doe, Jane Smith, etc."
                    </small>
                  </div>
                </div>
              </div>
              <!-- / Travel Consultant Name -->

              <!-- Notify of Incident Reports -->
              <div class="form-group row mb-4">
                <label for="notifyOfIncidentReports" class="col-form-label col-lg-2">Notify of Incident Reports</label>
                <div class="col-lg-10">
                  <div class="mb-3">
                    <table class="table table-bordered" style="max-width: 400px;">
                      <thead>
                        <tr>
                          <th style="border: none;"></th>
                          <th class="text-center">Group</th>
                          <th class="text-center">FIT</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="fw-bold">IAT</td>
                          <td class="text-center">
                            <div class="form-check d-flex justify-content-center">
                              <input class="form-check-input" type="checkbox" 
                                v-model="notifyOfIatGroupIncidentReports" />
                            </div>
                          </td>
                          <td class="text-center">
                            <div class="form-check d-flex justify-content-center">
                              <input class="form-check-input" type="checkbox" 
                                v-model="notifyOfIatFitIncidentReports" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fw-bold">IJT</td>
                          <td class="text-center">
                            <div class="form-check d-flex justify-content-center">
                              <input class="form-check-input" type="checkbox" 
                                v-model="notifyOfIjtGroupIncidentReports" />
                            </div>
                          </td>
                          <td class="text-center">
                            <div class="form-check d-flex justify-content-center">
                              <input class="form-check-input" type="checkbox" 
                                v-model="notifyOfIjtFitIncidentReports" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- / Notify of Incident Reports -->

               <!-- Escalate WhatsApp -->
               <div class="form-group row mb-4">
                <label for="escalateWhatsApp" class="col-form-label col-lg-2">Escalate WhatsApp?</label>
                <div class="col-lg-10">
                  <div class="mb-3 form-check">
                    <label class="form-check-label mt-1">
                      <input id="checkbox" class="form-check-input" name="escalateWhatsApp" type="checkbox"
                        :value="escalateWhatsApp" v-model="escalateWhatsApp" />
                      <div style="padding-top: 2px;">Yes, this user should be notified of WhatsApp escalations</div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- / Escalate WhatsApp --> 

            </form>
            <div class="row justify-content-end">
              <div class="col-lg-10">
                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped></style>
